export default __webpack_public_path__ + "static/media/logotype-on-light-client.ec688d4d.svg";